import FieldCustomizableEntity from "@/model/entities/resource/entity/FieldCustomizableEntity";

export default {
    data() {
        return {
            fieldCustomizable: new FieldCustomizableEntity(),
            error:{},
            error_fieldCustomizable: {
                name: "",
                type: "",
            },
            fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
                this.foreignKeyColumn,
            ],
        }
    },
    mounted() {

    },
    methods: {

        defaultFormField(){

            this.defaultFormList()
            this.cancelUpdatedField()

        },

        cancelUpdatedField() {

            this.command = "insert"
            this.status = ""
            this.form.orderList = 0
            this.form.status = 1
            this.form[this.primaryKeyColumn] = 0


            //----------------------------------------
            /*ATENÇÃO REPLICAR EM FieldCustomizableEntity.js*/
            this.form.fieldCustomizable = {
                fieldId: 0,
                name: "",
                type: "I",
                var: 3,
                mask: "",
                decimalPrecision: 2,
                length: 0,
                columns: 6,
                help: "",
                note: "",
                minAccepted: 0.0,
                maxAccepted: 0.0,
                createdShow: true,
                createdEnabled: true,
                updateShow: true,
                updatedEnabled: true,
                required: true,
                acceptZero: false,
                options: []
                /*ATENÇÃO REPLICAR EM FieldCustomizableEntity.js*/
            }
            //----------------------------------------

        },

    },

}


